import React, { useContext } from 'react';
import { Button, TextStyle } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import TabContext from '@nile/mangifera/src/Contexts/TicketContext';

interface BuyNowButtonProps {
  feature?: string;
}

const BuyNowButton = ({ feature }: BuyNowButtonProps) => {
  const tabContext = useContext(TabContext);

  const handleBuyNowClick = () => {
    if (tabContext && (tabContext as any).openTab) {
      (tabContext as any).openTab({
        module: 'ONBOARD',
        url: '/onboard/billing',
        state: {
          openModal: true
        }
      });
    }
  };

  return (
    <div className="buy-now-button">
      <Button onClick={handleBuyNowClick}>
        <TextStyle>
          <FormattedMessage id="app.pricing.buy.now" />
        </TextStyle>
      </Button>
    </div>
  );
};

export default BuyNowButton;
